import { AppButton } from "components";
import DashboardLayout from "layouts/DashboardLayout";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Router } from "utils/route";

export default function Download() {
  console.log("download");

  const [param] = useSearchParams();
  const tab = param.get("file");

  const { route } = Router();

  useEffect(() => {
    if (tab) {
    } else {
      route("/dashboard");
    }
    //eslint-disable-next-line
  }, []);
  return (
    <DashboardLayout>
      <div
        style={{
          marginBottom: "20px",
          fontSize: "26px",
          color: "#009bff",
        }}
      >
        CSV FILE
      </div>
      <div
        style={{
          marginBottom: "20px",
          fontSize: "20px",
        }}
      >
        <span
          style={{
            marginBottom: "20px",
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          File Name:
        </span>{" "}
        {tab?.slice(28) || "-"}
      </div>
      <a
        style={{
          textDecoration: "none",
        }}
        href={`${process.env.REACT_APP_BASE_URL}${tab}`}
      >
        <AppButton placeholder="Download Report"></AppButton>
      </a>
    </DashboardLayout>
  );
}
